export default "__VITE_ASSET__CVqo3QWY__"